var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCsv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#141b34",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.5 13v-.8037c0-2.96738 0-4.45107.46894-5.63606.75387-1.90503 2.3482-3.40769 4.36942-4.11823 1.25727-.44198 2.83144-.44198 5.97984-.44198 1.7991 0 2.6986 0 3.417.25256 1.155.40602 2.066 1.26469 2.4968 2.35328.268.67713.268 1.52495.268 3.22059v4.18774.9858",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.5 12c0-1.8409 1.49238-3.33333 3.33333-3.33333.66579 0 1.45071.11666 2.09804-.05679.57515-.15412 1.02439-.60336 1.17853-1.17852.1734-.64732.0568-1.43224.0568-2.09803 0-1.84095 1.4924-3.33333 3.3333-3.33333",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 17.2196c-.05542-1.1904-.87845-1.2196-1.99495-1.2196-1.71991 0-2.00505.406-2.00505 2v2c0 1.594.28514 2 2.00505 2 1.11649 0 1.93953-.0292 1.99495-1.2196m13-4.7804-1.7771 4.6947c-.3294.8702-.4941 1.3053-.7549 1.3053-.2609 0-.4256-.4351-.755-1.3053l-1.7771-4.6947m-2.5599 0h-1.1809c-.472 0-.7079 0-.894.0761-.6339.2593-.6253.8687-.6253 1.4239 0 .5553-.0086 1.1647.6253 1.4239.1861.0761.4221.0761.894.0761s.7078 0 .894.0761c.6338.2593.6252.8686.6252 1.4239s.0086 1.1647-.6252 1.4239c-.1862.0761-.4221.0761-.894.0761h-1.2862"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.6f70cb2762b59c636b4b36228b5794ca.svg";
export { ForwardRef as ReactComponent };